export default "__VITE_ASSET__CZXXzoXG__"